/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../core/store';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';
import { ProposalsFilters } from '../../model/proposalsQueryParams';
import {
  fetchProposalsCountries,
  selectIsFetching,
  selectProposalsCountries,
} from '../../store/auditProposalsAgendaSlice';

interface CountryMultiSelectFieldProps {
  filters: ProposalsFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function CountryMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: CountryMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchProposalsCountries(filters));
    }
  }, [dispatch, editable, filters]);

  const items = useSelector(selectProposalsCountries);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: string): SelectItem => {
    return {
      code: item,
      description: item,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='flag'
      loading={isFetching}
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={items.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.archive.filters.countries') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toString(i)));
        }
      }}
    />
  );
}
